import { Modal } from "react-bootstrap";

const ModalTwyny=(props)=>{
    return (
        <Modal show={props?.open} onHide={()=>{props?.setOpen(false)}} className="twyny-modal">
        
            <Modal.Body>
            <h3 className="grey500 mb-0">{props?.title}</h3> 
                {/* <p className="body mb-0 grey66 mt-24">
                    {props?.content}
                </p> */}
                    <div className="mt-40 mb-80">
        <div className="mx-auto">
          {" "}
          <h3 className="grey500 text-decoration-underline">
            ACCORD DE COOPÉRATION – TWYNY
          </h3>
          <p className="body mt-28 grey66 bold500">
            <p>
              Je soussigné « Le Partenaire » accepte de suivre les termes et
              conditions du contrat suivant.
            </p>
          </p>
          <p className="body grey66 mb-16">
            EPPOX SAS, nom commercial TWYNY ( « TWYNY »), est une société de
            droit français au capital social de 50 000,00 euros, dont le siège
            social est établi au 78, Av. des Champs-Elysées, Bureau 326, 75008
            Paris, France ; immatriculée au RCS de PARIS sous le numéro
            878115856.
          </p>
          <p className="body grey66 mb-16">
            TWYNY possède et exploite le site web{" "}
            <a href="wwww.twyny.com">twyny.com</a> (ci-après la «
            <span className="bold500 grey500">Plateforme</span> »), une
            plateforme de réservation en ligne par laquelle les partenaires
            participants (ci-après le(s) « Partenaire(s) ») peuvent,
            conformément aux conditions énoncées aux présentes, promouvoir et
            vendre des services et des services connexes, et qui permet aux
            utilisateurs de la Plateforme de réserver lesdits services en ligne.
          </p>
          <p className="body grey66 mb-16">
            Afin de bénéficier des services proposés par TWYNY et d'avoir accès
            à la plateforme, les Partenaires doivent accepter les conditions de
            service définies dans le présent accord (ci-après les «{" "}
            <span className="bold500 grey500">Conditions</span> » ou «{" "}
            <span className="bold500 grey500">l'Accord</span> »).
          </p>
          <p className="body grey66 mb-16">
            Les mots avec une majuscule initiale utilisés ci-après ont le sens
            qui leur est attribué dans le paragraphe correspondant.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 1     ACCORD</h4>
          <p className="body mt-16 grey66 bold500">
            Le Partenaire exerce dans le secteur des services et de services
            connexes (ci-après Ie «{" "}
            <span className="bold500 grey500">Service</span> » ou les «{" "}
            <span className="bold500 grey500">Services</span> ») et s'intéresse
            à la promotion et la vente desdits services par le biais de la
            plateforme sous son propre nom et sa marque.
          </p>
          <p className="body mt-16 grey66">
            Le présent Accord, qui régit l'accès et l'usage de la plateforme et
            des services connexes par le Partenaire est établi et conclu entre
            TWYNY et le Partenaire (ci-après les «{" "}
            <span className="bold500 grey500">Parties</span> » ou
            individuellement une «{" "}
            <span className="bold500 grey500">Partie</span> »).
          </p>
          <p className="body mt-16 grey66">
            Si le Partenaire est une personne morale, la personne qui accepte
            les présentes Conditions déclare qu'elle a le droit et l'autorité de
            contraindre juridiquement cette entité ou organisation à conclure le
            présent Accord.
          </p>
          <h4 className="grey500 mt-24">
            ARTICLE 2 DESCRIPTION DES SERVICES DE TWYNY
          </h4>
          <p className="body mt-16 grey66">
            TWYNY agit en tant qu'intermédiaire entre les Partenaires et les
            utilisateurs finaux ou les Clients et ne doit jamais et en aucun cas
            être considéré comme partie à des contrats conclus entre les
            Partenaires et les utilisateurs de la Plateforme qui ont conclu une
            Transaction (telle que définie ci-après) avec les Partenaires par le
            biais de la Plateforme (ci-après les « Clients »), c’est-à-dire que
            la réservation d'un Client par le biais de la Plateforme est ainsi
            juridiquement équivalente à une réservation faite directement auprès
            du Partenaire.
          </p>
          <p className="body mt-16 grey66">
            Les services fournis par TWYNY aux Partenaires par le biais de la
            Plateforme (ci-après les « Services de la Plateforme ») consistent à
          </p>
          <ul className="mt-40">
            <p className="body mt-16 grey66 bold50">
              <li>
                référencer toutes ou une partie des services (ci-après les «{" "}
                <span className="bold500 grey500">Services</span> ») du
                Partenaire sur la Plateforme en s'appuyant sur les informations
                fournies par le Partenaire ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
                permettre aux utilisateurs d'envoyer des demandes de réservation
                aux Partenaires ou d'acheter des Services comme décrit dans la
                Section « Procédure de réservation » des Conditions ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
                permettre la réalisation de paiements entre le Client et le
                Partenaire, pour le compte du Partenaire, comme décrit dans la
                Section « Services de paiement » des Conditions ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
                permettre aux Partenaires et aux Clients d'annuler des Services,
                avec des paiements ultérieurs automatisés, conformément aux
                politiques d'annulation ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
                accorder aux Partenaires un accès à un{" "}
                <span className="bold500 grey500">compte</span> personnel
                (ci-après le « Compte ») sur la Plateforme grâce auquel le
                Partenaire pourra accéder à la liste et la description de ses
                Services et gérer les réservations pour ce Service.
              </li>
            </p>
          </ul>
          <p className="body mt-16 grey66">
            Si le Partenaire le souhaite, TWYNY peut fournir des services
            supplémentaires (c'est-à-dire mettre en valeur les Services du
            Partenaire en produisant du contenu spécifique et/ou en envoyant des
            bulletins d'information aux utilisateurs de la
          </p>
          <p className="body mt-16 grey66">
            Plateforme). Ces services supplémentaires peuvent entraîner des
            coûts additionnels pour le Partenaire, tels qu'ils sont définis dans
            les tarifs de TWYNY fournis au Partenaire ou dans un accord distinct
            conclu entre les Parties.
          </p>
          <p className="body mt-16 grey66">
            Dans la mesure autorisée par la loi applicable, TWYNY ne fournit
            aucune déclaration, engagement ou garantie explicite, implicite ou
            statutaire liés à ou découlant de l'Accord ou des Services de la
            Plateforme de quelque manière que ce soit (y compris concernant la
            qualité marchande, la qualité satisfaisante ou la pertinence), sauf
            pour les déclarations, engagements et garanties stipulés
            expressément et sans ambiguïté dans les présentes Conditions. TWYNY
            ne donne, en particulier, aucune garantie concernant la
            disponibilité de la plateforme de manière discontinue, opportune,
            sûre, ou sans bugs/erreurs, ou quant au fait qu'il répondra aux
            besoins, exigences et attentes du Partenaire et/ou du Client.
          </p>
          <p className="body mt-16 grey66">
            La Plateforme TWYNY est conçue pour les Partenaires professionnels
            uniquement. En outre, TWYNY sera toujours en droit de décider, à son
            entière et seule discrétion, quels Partenaires et/ou Services sont
            listés sur la plateforme.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 3 OBLIGATIONS DU PARTENAIRE</h4>
          <ul className="mt-40">
            <p className="body mt-16 grey66 bold50">
              <li className="bold500 grey500">Informations</li>

              <p className="body mt-16 grey66">
                Le partenaire est tenu de remplir un formulaire d'inscription et
                de fournir à TWYNY toute information supplémentaire utile et/ou
                tout document raisonnablement exigé par TWYNY, y compris, sans
                s'y limiter :
              </p>

              <ul className="mt-16">
                <p>
                  O toute information et document à jour nécessaire pour
                  vérifier son identité, son statut juridique, ses actionnaires
                  et ses données de paiement ;
                </p>
                <p>
                  O les licences, diplômes et certificats professionnels, etc. ;{" "}
                  <br /> la police d'assurance, telle que <br /> décrite
                  ci-dessous ;
                </p>
                <p>O toute information concernant ses Services.</p>
              </ul>
              <li className="bold500 grey500">Déclarations et garanties</li>
              <p className="body mt-16 grey66">
                Le Partenaire déclare et garantit qu'il est une entreprise ou un
                professionnel dûment établi, qu'il restera seul responsable de
                tout Service réservé par le biais de la Plateforme et qu'il
                continuera, comme auparavant, pendant toute la durée de l'Accord
                :
              </p>

              <ul className="mt-40">
                <li>
                  {" "}
                  d'avoir les droits, le pouvoir et l'autorité nécessaires pour
                  conclure l'Accord et s'acquitter des obligations qui y sont
                  liées à tous égards ;
                </li>
                <li>
                  {" "}
                  d'être dûment organisé, d'exister valablement et d'être en
                  conformité avec les lois du pays dans lequel la société est
                  enregistrée, et qu'il est enregistré pour mener ses Services
                  dans ce pays ;
                </li>
                <li>
                  {" "}
                  de détenir toutes les licences, consentements, permis,
                  autorisations et accords nécessaires pour satisfaire à ses
                  obligations en vertu du présent Accord ;
                </li>
                <li>
                  {" "}
                  de détenir tous les permis, autorisations, licences, diplômes,
                  qualifications et autres autorisations exigés ou nécessaires
                  pour la réalisation de ses opérations et pour fournir les
                  Services (y compris, sans s'y limiter, toute qualification
                  professionnelle en lien avec le Service concerné) et de
                  fournir et d'exécuter tous les Services de manière
                  professionnelle et soignée, avec un degré élevé de prudence et
                  de diligence, et conformément à toutes les normes juridiques
                  (y compris la sécurité, la santé, etc.) des organisations et
                  associations professionnelles concernées ; - de garantir que
                  les Services proposées n'enfreignent pas les lois ou
                  réglementations en vigueur, les droits des tiers et la morale
                  ;
                </li>
                <li>
                  {" "}
                  de fournir les Services réservées par les Clients (sans
                  préjudice du point 3.6 ci-dessous) et de garantir un service à
                  la clientèle et une expérience client optimaux ;
                </li>
                <li>
                  {" "}
                  de superviser, contrôler et assumer l'entière responsabilité
                  des actions (ou absence d'action) de tout travailleur,
                  employé, membre du personnel temporaire, mandataire,
                  fournisseur, directeur, représentant, et de manière générale
                  toute personne impliquée ou contribuant à la fourniture du
                  Service/des Services (ci-après le «{" "}
                  <span className="bold500 grey500">Personnel</span> »).
                </li>
              </ul>
            </p>
          </ul>
          <p className="body mt-16 grey66">
            Le Partenaire s'engage à informer TWYNY immédiatement si une des
            déclarations et garanties ci-dessus ne peut pas être respectée ou
            s'il existe d'autres circonstances imminentes qui pourraient
            conduire au non-respect de celles-ci.
          </p>
          <p className="body mt-16 grey66">
            Le Partenaire reconnaît expressément qu'il ne revient pas à TWYNY de
            conseiller le Partenaire en matière de conformité et d'obligations,
            y compris les obligations d'ordre fiscal, imposées par la loi ou
            d'autres réglementations, et que le Partenaire en est le seul
            responsable.
          </p>
          <p className="body mt-16 grey66">
            Sauf disposition contraire explicite de TWYNY, le Partenaire fournit
            et mène les Services lui-même. Le Partenaire ne doit, en aucun cas,
            agir en tant que revendeur ou mandataire pour les Tiers et/ou
            proposer des Services menées, en réalité, par des sous-traitants.
          </p>
          <p className="body mt-16 grey66">
            Le Partenaire est responsable de tout le service client après-vente
            en lien ou découlant de ses Services, y compris, sans limitation, la
            gestion des réclamations, plaintes, demandes, recours ou litiges de
            Clients ou de tiers. Dans l'éventualité où TWYNY reçoit de tels
            appels ou toute autre forme de communication de la part de Clients
            ou de tiers concernant les Services, TWYNY fera tout son possible
            pour y répondre, mais pourra les transmettre au Partenaire.
          </p>
          <ul className="mt-16">
            <li className="bold500 grey500">Politique tarifaire</li>
            <p className="body mt-16 grey66">
              Le Partenaire garantit que les prix des Services proposées sur la
              Plateforme ne sont pas plus élevés que les prix proposés par le
              Partenaire sur son propre site web, catalogue ou par le biais
              d'une autre plateforme ou d'un autre canal, y compris les ventes
              directes sur le lieu d'exécution des Services.
            </p>
            <p className="body mt-16 grey66">
              Le prix de chaque Service devra comprendre toutes les taxes,
              frais, etc. Le Partenaire ne doit en aucun cas demander au Client
              de payer des taxes, des cotisations ou d'autres dépenses
              supplémentaires en lien avec les Services.
            </p>

            <li className="bold500 grey500">Contenu</li>
            <p className="body mt-16 grey66">
              Le Partenaire décrit ses Services conformément aux principes et
              aux exigences de la Plateforme. Les descriptions des Services
              doivent être complètes et exactes à tout moment (le Partenaire
              doit immédiatement informer TWYNY et actualiser ses informations
              en cas de changement ou si un service n'est plus disponible). Le
              Partenaire demeure le seul responsable de la transmission
              d'informations fiables aux utilisateurs de la Plateforme et aux
              Clients, y compris, sans s'y limiter, les descriptions exactes des
              Services et les prix.
            </p>
            <p className="body mt-16 grey66">
              En outre, le Partenaire se gardera d'envoyer ou de poster du
              Contenu qui pourrait (i) enfreindre toute loi ou réglementation en
              vigueur ou (ii) violer les droits, y compris les droits de
              propriété intellectuelle, de tout tiers, et/ou (iii) faire la
              promotion de tout service ou préférence
              politique/religieuse/sexuelle et/ou être jugée offensante de
              quelque manière que ce soit par un utilisateur (dans les présentes
              Conditions, « Contenu » désigne toute information et autre élément
              fourni par le Partenaire à TWYNY directement ou fourni par le
              Partenaire par le biais des Services de la Plateforme, y compris,
              sans s'y limiter, les documents, photos, textes, marques et
              informations en lien avec la présentation des Services).
            </p>
            <p className="body mt-16 grey66">
              Il est rappelé, et le Partenaire reconnaît et accepte que la
              présentation et l'inclusion de tout service et/ou Contenu sur la
              Plateforme soient à l'entière discrétion de TWYNY. TWYNY se
              réserve donc le droit de refuser de proposer un Service sur la
              Plateforme et/ou de publier un certain Contenu. En outre, TWYNY
              est en droit de modifier, actualiser ou supprimer des Services,
              et/ou du Contenu sur la Plateforme à tout moment. Toute
              modification apportée au Contenu du Partenaire par TWYNY doit être
              signalée au Partenaire dans un délai raisonnable. Nonobstant ce
              qui précède, TWYNY n'est pas autorisé à effectuer des
              modifications ayant un impact sur la substance du Service et/ou
              son prix.
            </p>
            <p className="body mt-16 grey66">
              Lors de la conclusion du présent Accord, si le Partenaire le
              souhaite, le Partenaire et TWYNY peuvent inclure des liens vers
              Ieurs sites web respectifs et le Partenaire peut publier le logo
              de TWYNY, avec un lien direct vers la Plateforme, sur son propre
              site web, à des fins d'optimisation SEO.
            </p>

            <li className="bold500 grey500">Procédure de réservation</li>
            <p className="body mt-16 grey66">
              Si aucun contrôle de disponibilité n'est nécessaire, ou si le
              Partenaire utilise le logiciel extranet TWYNY de gestion de
              réservations auquel TWYNY est connecté ou un logiciel tiers auquel
              TWYNY est connecté et qui permet la transmission de ses
              disponibilités sur la Plateforme en temps réel, l'utilisateur de
              la Plateforme peut réserver directement le Service et payer par
              carte de crédit ou tout autre moyen de paiement accepté par le
              biais de la Plateforme, et ainsi conclure la Transaction.
            </p>
            <p className="body mt-16 grey66">
              Si un contrôle de disponibilité est nécessaire, l'utilisateur de
              la Plateforme procède au paiement et dépose une demande de
              réservation par le biais de la Plateforme. TWYNY encaisse la somme
              correspondant au prix du Service en débitant la carte de crédit du
              Client (ou tout autre moyen de paiement). La demande de
              réservation est transmise automatiquement au Partenaire par
              courriel, SMS ou d'autres moyens de communication.
            </p>
            <p className="body mt-16 grey66">
              Le Partenaire est tenu de répondre aux demandes sous quarante-huit
              (48) heures. Si le Partenaire ne répond pas à la demande sous 48
              heures, TWYNY peut recommander à l'utilisateur de la Plateforme un
              autre Service similaire fournie par un autre Partenaire, et/ou
              rembourser la prestation.
            </p>
            <p className="body mt-16 grey66">
              Si la demande est acceptée, la réservation est confirmée et le
              contrat entre le Partenaire et le Client devient contraignant
              (ci-après la «{" "}
              <span className="bold500 grey500">Transaction</span> »).
            </p>

            <li className="bold500 grey500 mt-16"> Annulation</li>
            <p className="bold500 grey500 mt-16"> Principe général</p>
            <p className="body mt-16 grey66">
              La politique d'annulation du Service sera facilement accessible
              pour les utilisateurs de la Plateforme et sera transmise aux
              Clients dans le cadre du processus de réservation. La politique
              d'annulation fait partie intégrante de la Transaction.
            </p>
            <p className="bold500 grey500 mt-16"> Annulation par le Client</p>
            <p className="body mt-16 grey66">
              Le Client peut annuler une Transaction à tout moment, tout
              remboursement potentiel sera effectué dans le cadre de la
              politique d'annulation en vigueur.
            </p>
            <p className="body mt-16 grey66">
              Si le Client contacte directement le Partenaire pour annuler une
              Transaction, le Partenaire devra en informer TWYNY dans les
              meilleurs délais.
            </p>

            <p className="bold500 grey500 mt-16">
              Annulation par le Partenaire
            </p>
            <p className="body mt-16 grey66">
              Le Partenaire s'engage à fournir les Services réservés par les
              Clients. Le Partenaire peut uniquement annuler une Transaction si
              des circonstances imprévisibles rendent la réalisation du service
              impossible. (Par ex. cas de force majeure).
            </p>
            <p className="body mt-16 grey66">
              Le Partenaire informera TWYNY et le Client dans les meilleurs
              délais, de manière directe ou par le biais de la Plateforme.
              <p className="bold500 grey500 mt-16">
                Conséquences d'une annulation
              </p>
              <p className="body mt-16 grey66">
                Lorsque TWYNY sera informé de l'annulation, TWYNY traitera, le
                cas échéant, un remboursement au Client, conformément à la
                politique d'annulation qui s'applique au Service et à la
                Transaction. Lorsque le Client a droit à un remboursement
                partiel, l'argent restant sera versé au Partenaire, moins la
                Commission de TWYNY (telle que définie ci-dessous)/
              </p>
              <p className="body mt-16 grey66">
                Si un Client ne s'enregistre pas à l'heure prévue du Service
                réservé (non-présentation), le Partenaire est tenu d'en informer
                TWYNY dans un délai d'un (1) jour après la date
                d'enregistrement. Dans un tel cas, la somme facturée au Client
                par TWYNY pour le compte du Partenaire sera traitée comme si le
                Service avait été menée, et sera versée au Partenaire, moins la
                Commission de TWYNY (telle que définie ci-dessous).
              </p>
              <li className="bold500 grey500 mt-16">Assurance</li>
              <p className="body mt-16 grey66">
                Le Partenaire déclare qu'il a contracté, et qu'il conservera
                tant que les Conditions restent en vigueur, une assurance
                responsabilité civile professionnelle adéquate auprès d'une
                société d'assurance de premier rang, afin de couvrir tout
                dommage direct et indirect, y compris, sans s'y limiter, les
                dommages corporels (y compris la mort) et les dommages matériels
                (i) découlant de ou liés à la réalisation des Services qui sont
                attribuables directement ou indirectement au Partenaire, son
                Personnel et/ou ses associés, ou tout individu ou entité
                juridique qui travaille ou agit pour son compte, en quelque
                qualité que ce soit, et/ou (ii) en lien avec les obligations et
                garanties du Partenaire en vertu des présentes Conditions.
              </p>
              <p className="body mt-16 grey66">
                Le Partenaire s'engage à fournir à TWYNY une copie du/de tous
                le(s) certificat(s) d'assurance que détient le Partenaire en
                lien avec sa société et son/ses Service(s) au moment de
                l'acceptation des Conditions et chaque année.
              </p>
              <p className="body mt-16 grey66">
                TWYNY se réserve le droit de suspendre tous paiements au
                Partenaire, jusqu'à la transmission et la validation du (des)
                certificat(s) d'assurance susmentionné(s).
              </p>
              <li className="bold500 grey500 mt-16">Loyauté</li>
              <p className="body mt-16 grey66">
                Toutes les questions de Clients et les autres demandes de
                Clients reçues par le Partenaire directement ou indirectement
                via la Plateforme sont traitées par le biais de la Plateforme.
                Si un client potentiel provenant de la Plateforme réserve un
                Service en dehors de la Plateforme, le Partenaire le redirigera
                de bonne foi vers la Plateforme. La/Les Commission(s) sur
                cette/ces Transaction(s) conclues en dehors de la Plateforme
                est/sont due(s) comme si elle(s) avai(en)t été conclue(s) sur la
                Plateforme.
              </p>
              <li className="bold500 grey500 mt-16">
                Identifiant et mot de passe
              </li>
              <p className="body mt-16 grey66">
                Le Partenaire est responsable de garder secrets son nom
                d'utilisateur et son mot de passe pour accéder à son extranet
                TWYNY. Par mesure de précaution, TWYNY recommande à ses
                utilisateurs de modifier leur mot de passe régulièrement.
              </p>
              <p className="body mt-16 grey66">
                Le Partenaire sera pleinement responsable de toute action
                effectuée sur la Plateforme par toute personne ayant obtenu un
                accès à son Compte au moyen de son identifiant et de son mot de
                passe. TWYNY n'est pas responsable de tout dommage ou perte
                résultant de toute défaillance de sécurité causée par
                l'incapacité du Partenaire à garder secrets son nom
                d'utilisateur et son mot de passe.
              </p>
            </p>
          </ul>
          <h4 className="grey500 mt-24">ARTICLE 4 PAIEMENTS ET COMMISSIONS</h4>
          <ul>
            <li className="bold500 grey500 mt-16">
              Paiement initial des Clients et facturation
            </li>
            <p className="body mt-16 grey66">
              {" "}
              Le Partenaire autorise par la présente TWYNY à agir comme son
              mandataire à des fins de traitement des paiements et des
              remboursements relatifs aux Transactions.
            </p>
            <p className="body mt-16 grey66">
              {" "}
              Par conséquent, les Parties conviennent qu'au moment de la
              conclusion d'une transaction, le Client devra procéder au paiement
              correspondant au coût complet du Service.
            </p>
            <p className="body mt-16 grey66">
              {" "}
              Le Partenaire aidera TWYNY à lutter contre la fraude à la carte de
              crédit (par ex. une réservation frauduleuse découlant du vol et de
              l'utilisation non autorisée des informations de carte de crédit
              d'un tiers), qui peut se produire à la suite de Transactions. À ce
              titre, TWYNY peut demander au Partenaire de vérifier et de fournir
              l'identité du Client (par ex. passeport ou carte d'identité) avant
              de commencer le Service.
            </p>
            <p className="body mt-16 grey66">
              Concernant les factures, le Partenaire est le seul responsable
              pour :
            </p>
            <ul>
              <li className="body mt-16 grey66">
                établir les factures aux Clients conformément aux pratiques
                commerciales habituelles
              </li>
              <li className="body mt-16 grey66">
                déterminer si les Taxes (telles que définies ci-dessous)
                s'appliquent à la Transaction et percevoir, déclarer et verser
                les Taxes correctes à l'administration fiscale compétente (dans
                les présentes Conditions, « Taxe(s) » désigne toutes les taxes
                sur les ventes, les biens et les services, l'utilisation,
                l'exercice, l'importation, l'exportation, la valeur ajoutée, la
                consommation et d'autres taxes et droits évalués, encourus ou
                devant être perçus ou payés pour toute raison en lien avec toute
                publicité, offre ou vente de Services par le Partenaire sur ou
                par le biais de la Plateforme, ou en lien avec toute action,
                inaction ou omission de la part du Partenaire ou de tout membre
                de son Personnel).
              </li>
            </ul>
            <li className="bold500 grey500 mt-16">
              Coût des Services de la Plateforme
            </li>

            <p className="body mt-16 grey66">
              En ce qui concerne toute Transaction conclue par le biais de la
              Plateforme, le Partenaire dispose de deux formules :
            </p>
            <p className="body mt-16 grey66">
              {" "}
              - la formule sans engagement : le Partenaire paiera à TWYNY une
              commission de 3%. La Commission s'appliquera
              également à toute somme retenue auprès du Client en cas
              d'annulation, selon le cas. Le Partenaire est responsable de toute
              Taxe due et le Partenaire paiera à TWYNY la Commission sans
              réduction pour ces sommes.
            </p>
            <p className="body mt-16 grey66">
              La Commission elle-même peut être soumise à la TVA, conformément
              aux lois en vigueur.
            </p>
            <p className="body mt-16 grey66">
              {" "}
              La Commission sera facturée par TWYNY au Partenaire à chaque
              prestation, comme indiqué ci-dessous. Les factures correspondantes
              seront accessibles en utilisant le Compte du Partenaire sur la
              Plateforme.
            </p>
            <p className="body mt-16 grey66">
              {" "}
              - la formule sans commissions avec un plan tarifaire de 12 mois,
              24 mois et 36 mois payable à l’avance et à la souscription de la
              formule.
            </p>

            <li className="bold500 grey500 mt-16">
              Processus de paiement du solde
            </li>

            <p className="body mt-16 grey66">
              Toutes les transactions financières sont traitées par Ie(s)
              partenaire(s) du secteur des services financiers de TWYNY. Les
              fonds correspondants des clients sont conservés sur les comptes de
              TWYNY. TWYNY devient ainsi le débiteur du Partenaire jusqu'au
              paiement décrit ci-dessous.
            </p>
            <p className="body mt-16 grey66">
              {" "}
              Le 14ᵉ jour suivant la fin de chaque prestation, TWYNY calculera
              la somme due au Partenaire (ci-après le « Solde »), conformément
              aux principes suivants :
            </p>

            <ul>
              <p className="body mt-16 grey66">
                {" "}
                - la somme totale payée par les Clients pour les Services menés
                et terminés, ainsi que tous les montants retenus aux Clients en
                cas d'absence ; -moins les sommes correspondant aux Transactions
                contestées par des Clients (les sommes correspondant aux
                Transactions ou Services qui donnent lieu à un litige ne seront
                pas versées au Partenaire avant que le litige ne soit résolu en
                faveur du Partenaire) ; - moins la Commission due par le
                Partenaire à TWYNY et tout autre frais ou somme qui pourrait
                être dû par le Partenaire à TWYNY (tel que des frais relatifs à
                des services supplémentaires fournis par TWYNY).
              </p>
            </ul>

            <p className="body mt-16 grey66">
              La somme correspondant au Solde sera virée sur le compte bancaire
              du Partenaire au plus tard seize (16) jours suivant la fin de
              chaque mois, à condition que toute la documentation exigée par les
              lois et les réglementations en vigueur (souvent dénommés «
              documents KYC ») ainsi que les documents d'assurance et
              professionnels (valides) aient été fournis par le Partenaire à
              TWYNY et/ou son/ses partenaire(s) du secteur des services
              financiers, et que ce paiement n'enfreigne aucune Ioi ou
              réglementation.
            </p>
            <p className="body mt-16 grey66">
              Les frais bancaires standard et les autres coûts de transaction
              sont à la charge de TWYNY, sauf si la situation particulière du
              Partenaire engendre des coûts de transaction non standard (par ex.
              en raison du compte bancaire du Partenaire, de son système
              bancaire ou de la devise sélectionnée).
            </p>
            <p className="body mt-16 grey66">
              En raison des frais de virement bancaire dans certaines
              géographies (rendant l'utilisation du réseau SWIFT indispensable),
              TWYNY peut décider de retarder le paiement du Solde au Partenaire
              jusqu'à ce que le Solde atteigne un montant minimum variable, et
              au maximum de 1000 €, ou un montant équivalent dans la devise de
              paiement du Partenaire.
            </p>
          </ul>
          <h4 className="grey500 mt-24">ARTICLE 5 PROPRIÉTÉ INTELECTUELLE</h4>
          <p className="body mt-16 grey66">
            La Partenaire reconnaît que TWYNY détient tous les droits (y compris
            les droits de propriété intellectuelle) relatifs à la Plateforme et
            les marques, logos, contenus, codes source, etc. associés (ci-après
            les « <span className="bold500 grey500">Propriétés</span> »).
            L'Accord n'accorde au Partenaire aucun droit, implicite ou autre,
            concernant/sur les Propriétés.
          </p>
          <p className="body mt-16 grey66">
            {" "}
            Afin de promouvoir les Services et la Plateforme et d'assurer les
            Services de la Plateforme, le Partenaire autorise TWYNY à utiliser,
            reproduire et adapter tous les éléments du Contenu. La licence
            mondiale est délivrée gratuitement, car le Partenaire comprend qu'il
            est nécessaire, et dans son intérêt, d'autoriser TWYNY à promouvoir
            les Services et la Plateforme. Cette licence comprend le droit pour
            TWYNY d'utiliser et d'afficher le Contenu, y compris les marques et
            logos du Partenaire via différents supports de commercialisation.
          </p>
          <p className="body mt-16 grey66">
            Les droits accordés par la présente à TWYNY peuvent être concédés en
            sous-licence par ce dernier à toute filiale, sous-traitant ou
            partenaire, en particulier les partenaires affiliés par le biais
            desquels les Services pourraient être proposés ou promus.
          </p>
          <p className="body mt-16 grey66">
            Le Partenaire devra obtenir tous les consentements, licences ou
            autorisations nécessaires pour autoriser TWYNY à utiliser, exploiter
            et/ou adapter le Contenu. Le Partenaire indemnisera et dégagera
            TWYNY de toute responsabilité contre toute obligation découlant de
            l'incapacité du Partenaire à remplir cette obligation.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 6 PROTECTION DES DONNÉES</h4>
          <p className="body mt-16 grey66">
            Chaque Partie garantit et s'engage à respecter scrupuleusement ses
            obligations conformément à l'ensemble des lois sur la protection des
            données en vigueur (ci-après les «{" "}
            <span className="bold500 grey500">
              Lois sur la protection des données
            </span>{" "}
            »).
          </p>
          <p className="body mt-16 grey66">
            Le Partenaire demeure le seul responsable, dans sa capacité de
            contrôleur des données personnelles, de déterminer les finalités et
            les moyens du traitement des données personnelles du Partenaire par
            TWYNY en vertu de l'Accord, étant précisé que les données
            personnelles du Partenaire comprennent les données personnelles du
            Client traitées par le Partenaire.
          </p>
          <p className="body mt-16 grey66">
            Le Partenaire indemnisera et dégagera TWYNY de toute responsabilité
            contre tout coût, réclamation, dommage, perte, dépense et obligation
            découlant ou en lien avec tout avis, action, réclamation, demande ou
            allégation selon laquelle tout traitement de données personnelles du
            Partenaire entrepris par TWYNY conformément aux instructions du
            Partenaire viole les droits de tout tiers ou est de toute manière
            contraire aux dispositions des Lois sur la protection des données.
          </p>
          <h4 className="grey500 mt-24">
            ARTICLE 7 GARANTIE ET RESPONSABILITÉ
          </h4>
          <p className="bold500 grey500 mt-16">
            TWYNY n'est pas partie à la transaction conclue entre le partenaire
            et le client
          </p>
          <p className="body mt-16 grey66">
            TWYNY agit en tant que simple intermédiaire entre les utilisateurs
            finaux et les Partenaires, et n'est donc pas partie aux contrats
            conclus entre les Partenaires et les Clients et n'est pas impliqué
            dans l'exécution des Services ou des Transactions.
          </p>
          <p className="bold500 grey500 mt-16">
            TWYNY décline toute responsabilité en lien avec les Services
          </p>
          <p className="body mt-16 grey66">
            TWYNY ne saurait en aucun cas être tenu responsable en cas de
            préjudice, de perte ou de dommage causé par le Client au Partenaire
            ou par le Partenaire au Client ou par/à des tiers en lien avec les
            Services, indépendamment de la nature des dommages ou de la perte
            (qu'ils soient directs, indirects, consécutifs ou autres). Si un
            litige survient entre le Partenaire et le Client ou un tiers, le
            Partenaire dégage TWYNY, ses sous-traitants et leurs mandataires
            respectifs, les dirigeants et les employés des réclamations,
            demandes et dommages de quelque nature qu'ils soient, connus et
            inconnus, prévus et imprévus, découlant ou liés d'une quelconque
            manière à ces litiges. Entre autres, à titre d'exemple, TWYNY
            décline toute responsabilité pour tout dommage corporel ou matériel
            découlant ou en lien avec les Services et/ou l'exécution ou la
            non-exécution d'un contrat conclu entre le Partenaire et un Client
            ou un tiers, et le Partenaire indemnisera et dégagera TWYNY de toute
            responsabilité contre tous les coûts, pertes, dommages et/ou
            dépenses à cet égard.
          </p>
          <p className="bold500 grey500 mt-16">
            Le Partenaire défendra et dégagera TWYNY de toute responsabilité
            contre toute réclamation en lien avec les Services.
          </p>
          <p className="body mt-16 grey66">
            Le Partenaire défendra, indemnisera et dégagera TWYNY, ses filiales
            et leurs responsables, directeurs, employés et mandataires de toute
            responsabilité contre toute réclamation, perte, dépense, coût,
            dommage ou jugement directement ou indirectement découlant ou en
            lien avec l'exécution des Services (ou l'annulation ou la
            non-exécution des Services par le Partenaire pour une raison
            quelconque).
          </p>
          <p className="bold500 grey500 mt-16">
            Si TWYNY était tenu responsable, sa responsabilité serait limitée
            aux dommages directs et au montant des Commissions payées par le
            Partenaire à TWYNY au cours des 6 mois précédents. En outre, toute
            réclamation devra être déposée dans un délai de prescription d’1 an.
            Toutes les limitations de responsabilité énoncées aux présentes
            continueront d'exister après la résiliation de l'Accord et resteront
            en vigueur même si l'Accord est invalide ou inapplicable.
          </p>
          <p className="body mt-16 grey66">
            Sans préjudice de ce qui précède, il est expressément convenu, dans
            tous les cas, que :
          </p>
          <ul>
            <li className="body mt-16 grey66">
              TWYNY ne pourra en aucun cas être tenu responsable pour les
              dommages indirects, y compris, sans limitation, les pertes de
              bénéfices, les défections de clients, les pertes d'activité, les
              pertes de revenus, les pertes de contrats, les pertes d'économies
              anticipées, les pertes de données, les pertes de clientèle, les
              dommages causés ou l'altération de données ou d'informations
              commerciales.
            </li>
            <li className="body mt-16 grey66">
              sauf et uniquement dans la mesure où le rejet de responsabilité
              susmentionné est expressément interdit par la loi en vigueur, la
              responsabilité totale de TWYNY pour la durée de l'Accord, pour
              toutes les réclamations et les dommages découlant d'une
              négligence, d'une rupture du contrat, d'une garantie ou d'une
              indemnisation, ou toute autre raison ou base juridique, dans le
              cadre ou en lien avec l'Accord et/ou les Services de la
              Plateforme, ne pourra excéder un montant équivalent aux
              Commissions (hors taxes) dues ou payées par le Partenaire à TWYNY
              dans le cadre de l'Accord pendant les six (6) mois précédant
              immédiatement l'évènement (le plus récent) ayant donné naissance à
              la responsabilité ;
            </li>
            <li className="body mt-16 grey66">
              dans la mesure permise par la loi en vigueur (conformément à
              l'Article 12), toute réclamation ou cause d'action découlant ou
              liée à la Plateforme ou aux Services de la Plateforme, ou en lien
              avec le présent Accord, doit être déposée dans un délai d'un an
              suivant la survenue de cette réclamation ou cause d'action, faute
              de quoi elle sera prescrite à jamais ;{" "}
            </li>
            <li className="body mt-16 grey66">
              toute disposition de limitation de responsabilité contenue dans le
              présent Article 7 continuera d'exister après l'expiration ou la
              résiliation de l'Accord pour quelque raison que ce soit,{" "}
            </li>
            <li className="body mt-16 grey66">
              les limitations de responsabilité prévues en vertu du présent
              Article 7 comprennent et s'appliquent à la fois à toute
              responsabilité expressément prévue en vertu du présent Accord et à
              toute responsabilité découlant de l'invalidité ou de
              l'inapplicabilité des conditions du présent Accord.{" "}
            </li>
          </ul>
          <h4 className="grey500 mt-24">ARTICLE 8 MODIFICATIONS</h4>
          <p className="body mt-16 grey66">
            TWYNY se réserve le droit de modifier les présentes Conditions
            occasionnellement. La dernière version sera disponible à tout moment
            sur la Plateforme et/ou sur le Compte du Partenaire.
          </p>
          <p className="body mt-16 grey66">
            TWYNY pourra demander au Partenaire d'accepter des Conditions
            actualisées de manière spécifique. Si le Partenaire n'accepte pas
            ces Conditions actualisées, le Partenaire en informera TWYNY et
            cessera d'utiliser la Plateforme et les Services de la Plateforme.
            Dans le cas contraire, le Partenaire sera réputé avoir accepté les
            modifications.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 9 DURÉE ET RÉSILIATION</h4>
          <p className="body mt-16 grey66">
            Le présent Accord entrera en vigueur dès l'acceptation des présentes
            conditions par le Partenaire et restera exécutoire tant que le
            Partenaire propose des Services sur la Plateforme.
          </p>
          <p className="body mt-16 grey66">
            Chacune des Parties peut résilier le présent Accord à tout moment,
            pour quelque raison que ce soit et sans fournir de justification à
            l'autre Partie, en transmettant un préavis écrit d'un mois à l'autre
            Partie. Dans ce cas, le Partenaire cessera immédiatement de proposer
            des Services sur la Plateforme. Si une ou plusieurs services déjà
            réservés et payés par un Client sont programmées après cette période
            de 30 jours, ces services seront menés par le Partenaire et les
            Commissions y afférentes seront payées. Dans ce cas, les Conditions
            resteront en vigueur dans une mesure suffisante pour assurer lesdits
            Services.
          </p>
          <p className="body mt-16 grey66">
            En outre, TWYNY pourra, de manière immédiate et sans préavis,
            résilier le présent Accord et/ou révoquer l'accès à la Plateforme si
            (i) le Partenaire a manqué de manière importante à ses obligations
            en vertu des présentes Conditions, (ii) le Partenaire a enfreint les
            lois, réglementations ou droits de tiers en vigueur, ou (iii) TWYNY
            considère de bonne foi que cette action est raisonnablement
            nécessaire pour garantir la sécurité personnelle ou la propriété de
            TWYNY, de la Plateforme, des utilisateurs de la Plateforme et/ou de
            tiers.
          </p>
          <p className="body mt-16 grey66">
            Au moment de la résiliation de l'Accord pour quelque raison que ce
            soit, les clauses des présentes Conditions qui devraient
            raisonnablement continuer d'exister après la résiliation de l'Accord
            resteront en vigueur, y compris en ce qui concerne la responsabilité
            du Partenaire quant aux Services réservés et/ou menés avant la
            résiliation.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 10 FOURNISSEUR INDÉPENDANT</h4>
          <p className="body mt-16 grey66">
            Le Partenaire agira en tant que fournisseur indépendant. Aucune
            disposition du présent Accord ne doit être interprétée comme créant
            une relation de mandant et mandataire, sous-traitant, employeur et
            employé, partenaires ou entreprise commune.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 11 DIVERS</h4>
          <p className="body mt-16 grey66">
            Le Partenaire et TWYNY s'autorisent mutuellement à citer la
            Plateforme, le Partenaire et/ou ses Services sur tout moyen de
            communication, afin de promouvoir la Plateforme et/ou les Services.
          </p>
          <p className="body mt-16 grey66">
            Le Partenaire garantira la confidentialité des présentes Conditions
            (en particulier toute disposition concernant les Commissions). Cette
            obligation restera valable pendant cinq (5) ans après l'expiration
            ou la résiliation de l'Accord.
          </p>
          <p className="body mt-16 grey66">
            Si le Partenaire connaît un changement de propriétaire ou transfert
            une partie ou toute son activité à une autre partie, le Partenaire
            devra informer TWYNY des changements prévus par écrit au moins
            quatorze jours avant l'entrée en vigueur de ces changements. L'envoi
            d'un avis à TWYNY ne constitue pas une cession de l'Accord.
          </p>
          <p className="body mt-16 grey66">
            Le présent Accord est considéré comme dissociable, et l'invalidité
            ou l'inapplicabilité de toute condition ou disposition du présent
            Accord n'affectera pas la validité ou l'applicabilité du présent
            Accord ou de tout autre condition ou disposition de celui-ci En
            outre, à la place de toute condition ou disposition invalide ou
            inapplicable, les Parties au présent Accord prévoient que sera
            ajoutée, dans le cadre du présent Accord, une disposition la plus
            similaire possible en termes d'une telle disposition invalide ou
            inapplicable, qui sera valide et applicable.
          </p>
          <h4 className="grey500 mt-24">
            ARTICLE 12 RÉSOLUTION DES LITIGES — LOI APPLICABLE - JURIDICTION
          </h4>
          <p className="body mt-16 grey66">
            Le présent Accord sera régi et appliqué conformément aux lois
            françaises. Tout litige, controverse ou réclamation découlant ou
            liés au présent Accord ou la rupture, l'interprétation, la
            résiliation ou la validité de celui-ci qui ne peut pas être résolu
            par accord mutuel des Parties sera soumis à la compétence exclusive
            du Tribunal de commerce de PARIS.
          </p>
        </div>
      </div>
                <div className="d-flex flex-wrap justify-content-between mt-24">
                   <button className='twyny-cta-secondary ' onClick={()=>{props?.setOpen(false)}}>
            Annuler
          </button>
         <button className="twyny-cta-primary mr-8" onClick={()=>{props?.Accept()}} >
          J’accepte le contrat d’utilisation Twyny
          </button> 
         
                </div>
                
            </Modal.Body>
       
       
      </Modal>
      );
}
export default ModalTwyny